module.exports = __webpack_public_path__ + "static/pattern design-06-e9496c1118fa51e6d131a8154590ec9f.jpg";